export default {
    en: {
        number: 9,
        diagramId: 8,
        answers: 'Uncertainty paralyzes paralysis results in',
        interactiveBoxNumber: [1],
        blocks:
            [
                {
                    task: {
                        question: 'Uncertainty in government policy paralyzes, making businesses and consumers less sensitive to outside forces',
                        answer: '<span class="correct-answer-box"><span class="highlight__answer highlight__answer_correct">Uncertainty</span> in government policy <span class="highlight__answer highlight__answer_correct">paralyzes</span>, making businesses and consumers less sensitive to outside forces</span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'The paralysis results in productive firms being slow to expand, and unproductive firms slow to contract',
                        answer: '<span class="correct-answer-box">The <span class="highlight__answer highlight__answer_correct">paralysis results in</span> productive firms being slow to expand, and unproductive firms slow to contract</span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'Thus resources don’t get reallocated, shutting down the primary mechanism for increasing productivity',
                        answer: '<span class="correct-answer-box">Thus resources don’t get reallocated, shutting down the primary mechanism for increasing productivity</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise9.js